import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  border?: boolean
}

const TabList = ({ children, border = false }: Props) => {
  return (
    <>
      <ul
        className={clsx(
          'flex items-center justify-start px-2',
          border && 'w-full border-b border-primary'
        )}
      >
        {children}
      </ul>
    </>
  )
}

export default TabList
